import { request } from "@/utils/http";
import { Loading } from "element-ui";
let orderpre = "/fronted/order/pretreatment";
let orderCount = "/fronted/order/counter";
let orderList = "/fronted/order/list";
let orderdetail = "/fronted/order/detail";
let ordersubmit = "/fronted/order/submit";
let ordercod = "/fronted/order/cod";
let orderConfirm = "/fronted/order/confirm";
let orderCheck = "/fronted/order/check";
let orderRepurchase = "/fronted/order/repurchase";
let orderItemDetail = "/fronted/order/item/";
let purchaserecord = "/fronted/goods/purchase/record";

export function POST_OREDERPRE(params) {
  const loading = Loading.service({ fullscreen: true });
  return request(orderpre, "post", params).then(res => {
    loading.close();
    return res;
  });
}
export function GET_ORDERCOUNT(params) {
  return request(orderCount, "get", params);
}
export function GET_ORDERLIST(params) {
  return request(orderList, "get", params);
}
export function GET_ORDERDETAIL(params) {
  return request(orderdetail, "get", params);
}
export function POST_ORDERSUBMIT(params) {
  const loading = Loading.service({ fullscreen: true });
  return request(ordersubmit, "post", params).then(res => {
    loading.close();
    return res;
  });
}
export function POST_ORDERCOD(params) {
  return request(ordercod, "post", params);
}
export function POST_ORDERCONFIRM(params) {
  return request(orderConfirm, "post", params);
}
export function GET_ORDERCHECK(params) {
  return request(orderCheck, "get", params);
}
export function POST_ORDERREPURCHASE(params) {
  return request(orderRepurchase, "post", params);
}
export function GET_ORDERITEM(params) {
  return request(orderItemDetail + params.orderItemId, "get", params);
}
export function GET_PURCHASECORD(params) {
  return request(purchaserecord, "get", params);
}



// WEBPACK FOOTER //
// ./src/api/order.api.js